import api from "../config/api";

export const getContracts = async ({ userId, type = "client" }) => {
  if (!userId) {
    throw new Error("[GET_CONTRACTS] User ID missing.");
  }

  const isCustomer = type === "customer";

  const url = `/platform/contracts/${
    isCustomer ? `customer/${userId}` : userId
  }`;

  const { data } = await api.get(encodeURI(url));
  return data;
};

export const getContractsByContactId = async ({ userId, contactId }) => {
  if (!userId) {
    throw new Error("[GET_CONTRACTS_BY_CONTACT_ID] User ID missing.");
  }

  if (!contactId) {
    throw new Error("[GET_CONTRACTS_BY_CONTACT_ID] Contact ID missing.");
  }

  const { data } = await api.get(
    `/platform/contracts/${userId}/contact/${contactId}`
  );

  return data;
};

export const getContractById = async ({ userId, contractId }) => {
  if (!userId) {
    throw new Error("[GET_CONTRACTS_BY_CONTRACT_ID] User ID missing.");
  }

  if (!contractId) {
    throw new Error("[GET_CONTRACTS_BY_CONTRACT_ID] Contract ID missing.");
  }

  const { data } = await api.get(`/platform/contracts/${userId}/${contractId}`);

  return data;
};

export const createContract = async ({ userId, payload }) => {
  if (!userId) {
    throw new Error("[CREATE_CONTRACT] User ID missing.");
  }

  if (!payload) {
    throw new Error("[CREATE_CONTRACT] Payload missing.");
  }

  const { data } = await api.post(`/platform/contracts/${userId}`, payload);
  return data;
};

export const updateContract = async ({ userId, contractId, payload }) => {
  if (!userId) {
    throw new Error("[UPDATE_CONTRACT] User ID missing.");
  }

  if (!contractId) {
    throw new Error("[UPDATE_CONTRACT] Contract ID missing.");
  }

  if (!payload) {
    throw new Error("[UPDATE_CONTRACT] Payload missing.");
  }

  const { data } = await api.patch(
    `/platform/contracts/${userId}/${contractId}`,
    payload
  );

  return data;
};

export const deleteContract = async ({ userId, contractId }) => {
  if (!userId) {
    throw new Error("[DELETE_CONTRACT] User ID missing.");
  }

  if (!contractId) {
    throw new Error("[DELETE_CONTRACT] Contract ID missing.");
  }

  const { data } = await api.delete(
    `/platform/contracts/${userId}/${contractId}`
  );

  return data;
};

export const downloadContract = async ({ userId, payload }) => {
  if (!userId) {
    throw new Error("[DOWNLOAD_CONTRACT] User ID missing.");
  }

  if (!payload) {
    throw new Error("[DOWNLOAD_CONTRACT] Payload missing.");
  }

  const { data } = await api.post(`/settings/download_url/${userId}`, payload);

  return data;
};

export const sendContractEmail = async ({ userId, contractId }) => {
  if (!userId) {
    throw new Error("[SEND_CONTRACT_EMAIL] User ID missing.");
  }

  if (!contractId) {
    throw new Error("[SEND_CONTRACT_EMAIL] Contract ID missing.");
  }

  const { data } = await api.post(
    `/platform/contracts/${userId}/send_email/${contractId}`,
    {}
  );

  return data;
};

export const createSmartContract = async (
  userId,
  contractText,
  invoiceId = null,
  contactId = null,
  uploadedDate = new Date()
) => {
  if (!userId) {
    throw new Error("[CREATE_SMART_CONTRACT] User ID missing.");
  }

  const payload = {
    uploaded_date: uploadedDate,
    contact_id: contactId,
    invoice_id: invoiceId,
    contract_text: contractText,
    is_smart_contract: true,
    contract_status: "pending",
  };

  const { data } = await api.post(
    `/platform/contracts/${userId}/smart_contract`,
    payload
  );

  return data;
};

export const getContractMissingData = async (userId, contractText) => {
  if (!userId) {
    throw new Error("[GET_CONTRACT_MISSING_DATA] User ID missing.");
  }

  if (!contractText) {
    throw new Error("[GET_CONTRACT_MISSING_DATA] Text missing.");
  }

  const payload = {
    text: contractText,
  };

  const { data } = await api.post(
    `/platform/contracts/get_missing_info/${userId}`,
    payload
  );

  return data.field_list;
};

export const getInvoicesFromContract = async (userId, contractText) => {
  if (!userId) {
    throw new Error("[GET_INVOICES_FROM_CONTRACTS] User ID missing.");
  }

  if (!contractText) {
    throw new Error("[GET_INVOICES_FROM_CONTRACTS] Text missing.");
  }

  const payload = {
    text: contractText,
  };

  const { data } = await api.post(
    `/platform/contracts/get_invoices_from_contract/${userId}`,
    payload
  );

  return data;
};

export const changeContractStatus = async ({
  clientId,
  contractId,
  contractStatus,
  deliveryOption,
}) => {
  if (!clientId) {
    throw new Error("[CHANGE_CONTRACT_STATUS] Client ID missing.");
  }

  if (!contractId) {
    throw new Error("[CHANGE_CONTRACT_STATUS] Contract ID missing.");
  }

  if (!contractStatus) {
    throw new Error("[CHANGE_CONTRACT_STATUS] Contract status missing.");
  }

  const payload = {
    contract_status: contractStatus,
    platform_id: clientId,
    contract_id: contractId,
  };

  // Add delivery_option to payload if it's not undefined
  if (deliveryOption !== undefined) {
    payload.delivery_option = deliveryOption;
  }

  const { data } = await api.patch(
    `/platform/contracts/customer/status`,
    payload
  );

  return data;
};
